import {
  IBasePagingRes,
  IBaseResponseModel,
} from "../../models/common/models.type";
import api from "../remote/baseApi";
import ApiEndpoints from "../remote/apiEndpoints";
import { envConfig } from "../../config/env.config";
import { EContentResponse, ESeoResponse } from "../../models/seo";
import { EBlogResponse, IBlogGetPage } from "../../models/blog";
import { IVisitRequest, VisitStatisticResponse } from "../../models/visit";

const API = ApiEndpoints.VISIT;

const baseURL = envConfig.API_ENDPOINT;

const getStatistics = async (
  type: number,
): Promise<IBaseResponseModel<VisitStatisticResponse[]>> => {
  return api.get(baseURL, API.GetStatistics.url + "?type=" + type);
  //return res;
};

const getDeviceStatistics = async (): Promise<IBaseResponseModel<any>> => {
  return api.get(baseURL, API.GetDeviceStatistics.url);
  //return res;
};

const getUserOnline = async (): Promise<IBaseResponseModel<any>> => {
  return api.get(baseURL, API.GetUserOnline.url);
  //return res;
};

const create = async (
  data: IVisitRequest,
): Promise<IBaseResponseModel<any>> => {
  return api.post(baseURL, API.Create.url, data);
  //return res;
};

const getGetCountryCode = async (): Promise<IBaseResponseModel<string>> => {
  return api.get(baseURL, API.GetGetCountryCode.url);
  //return res;
};

const VisitService = {
  getStatistics,
  create,
  getGetCountryCode,
  getUserOnline,
  getDeviceStatistics,
};

export default VisitService;
